import { FC, memo, useCallback, useMemo } from "react"

import { CheckboxDecorative, Text } from "@izettle/react"

import { useDropdown } from "../../hooks"
import { OptionPropsWithChildren } from "../../types"
import { DropdownItemContainer, DropdownItem } from "../internal"

import { LabelWrapper } from "./components"

export const Option: FC<OptionPropsWithChildren> = memo((props) => {
  const { children, isIndeterminate, value, label, disabled = false } = props
  const { isMultiple, getIsOptionSelected, handleValueChange, close } = useDropdown()

  const isSelected = getIsOptionSelected(props)

  const handleClick = useCallback(() => {
    if (!disabled) {
      handleValueChange(value)
    }
    if (!isMultiple) {
      close()
    }
  }, [close, isMultiple, handleValueChange, value, disabled])

  const labelMarkup = useMemo(() => {
    const TextComponent = isIndeterminate || isSelected ? Text.RegularBold : Text.Regular
    return (
      <LabelWrapper disabled={disabled}>
        <TextComponent marginTop="none" marginBottom="none">
          {children ?? label}
        </TextComponent>
      </LabelWrapper>
    )
  }, [isIndeterminate, isSelected])

  return (
    <DropdownItem onClick={handleClick}>
      <DropdownItemContainer tabIndex={-1}>
        {isMultiple && (
          <CheckboxDecorative
            checked={isSelected}
            indeterminate={isIndeterminate}
            disabled={disabled}
          />
        )}
        {labelMarkup}
      </DropdownItemContainer>
    </DropdownItem>
  )
})
